import { Injectable } from '@angular/core';

@Injectable()
export class SettlementService {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/settlement.service.ts